import { AccionesGenericas } from "./AccionesGenericas";
import type { Paquete } from "@/interfaces/paquetes.interface";
import {
  EditPaqueteForm,
  DetallePaquete,
} from "../forms/paquetes/PaqueteForms";
import { useDeleteLogicoPaquete } from "@/hooks/paquetes/usePaquetes";

type AccionesPaqueteProps = {
  paquete: Paquete;
  queryKey?: ReadonlyArray<unknown>;
};

export default function AccionesPaqueteCell({
  paquete,
  queryKey = ["paquetes"],
}: AccionesPaqueteProps) {
  const { mutate } = useDeleteLogicoPaquete({
    queryKey,
  });

  return (
    <AccionesGenericas
      data={paquete}
      id={paquete.id}
      label="Paquete"
      queryKey={queryKey}
      FormularioEdicion={EditPaqueteForm}
      onDelete={(id) => mutate(id)}
      DetalleContenido={DetallePaquete}
    />
  );
}
